// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__F11kg","left":"styles_left__BUpCU","desktopActions":"styles_desktopActions__27ss_","title":"styles_title__29fn2"};